<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column prop="code" label="编号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="logo" label="图片" align="center">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.logo"
                        :preview-src-list="[scope.row.logo]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="startDate" label="开始日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.startDate }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="结束日期" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.endDate }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="enable" label="是否启用" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.enable ? "是" : "否" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleLook(scope.$index, scope.row)"
                  >查看
                  </el-button
                  >
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      @click="handleCopy(scope.$index, scope.row)"
                  >复制
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditMeetingManage
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditMeetingManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditMeetingManage from "../../../components/ticketing/meeting/EditMeetingManage";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      totalPage: 0,
      dataList: [],
      arrayList: [],
      multipleSelection: [],
      listShow: true,
      delVisible: false,
      editShow: false,
      editData: {},
      searchForm: {
        name: "",
      },
      meetingId: "",
      projectId: localStorage.getItem("project_Id"),
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleCloseVisible() {
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCopy(index, row) {
      if (confirm("是否拷贝行")) {
        let data = JSON.parse(JSON.stringify(row));
        data.meetingId = null;
        data.name += "-拷贝"
        this.$axios.post(`/Meeting/`, data).then((res) => {
          if (res.data.hasError) {
            this.$message.error(res.data.message);
          } else {
            this.$message.success("新增成功！");
            this.getData();
          }
        });
      }
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.meetingId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        projectId: this.projectId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
      };
      this.$axios.post("/Meeting/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    deleteData() {
      this.$axios
          .delete(`/Meeting/${this.meetingId}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    handleLook(index, row) {
      window.open(localStorage.getItem("url").replace("/api", "") + '/bigdata_meeting?projectId=' + row.projectId + '&id=' + row.name)
    },
    handleDelete(index, row) {
      this.meetingId = row.meetingId;
      this.delVisible = true;
    }
  },
  components: {
    EditMeetingManage,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.el-main {
  border-radius: 5px;
  position: relative;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;

  .btn-r {
    margin-right: 20px;
  }
}

.pag {
  position: absolute;
  bottom: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.el-dialog {
  height: auto;
}
</style>